<template>
          <el-dialog
      :close-on-click-modal="false"
  title="提示"
  :visible.sync="verificationVisible"
  width="30%"
  :before-close="handleClose">
  <el-form :model="data" :rules="rules" ref="ruleForm" label-width="100px" label-suffix=':' class="demo-ruleForm">
  <el-form-item label="款项名称" prop="paymentTitle">
     {{data.paymentTitle}}
  </el-form-item>
  <el-form-item label="付款金额" prop="paymentAmount">
     {{getMoney(data.paymentAmount)}}
  </el-form-item>
  <el-form-item label="预计付款日期" prop="planDate">
     {{data.planDate}}
  </el-form-item>
  <el-form-item label="客户经理" prop="managerName">
     <!-- {{data.contract.managerName}} -->
  </el-form-item>
  <el-form-item label="付款人开户行" prop="payOpeningBank">
     {{data.payOpeningBank}}
  </el-form-item>
  <el-form-item label="付款人户名" prop="payAccountName">
     {{data.payAccountName}}
  </el-form-item>
  <el-form-item label="付款人账号" prop="payBankAccount">
     {{data.payBankAccount}}
  </el-form-item>
  <el-form-item label="核销日期" prop="verificationTime">
    <el-date-picker
      v-model="data.verificationTime"
      type="date"
      placeholder="选择日期"
      value-format="yyyy-MM-dd"
      >
    </el-date-picker>
  </el-form-item>
 
  </el-form>
   <span> 
    <el-button @click="verificationVisible = false">取 消</el-button>
    <el-button type="primary" @click="verificheck()">确 定</el-button>
  </span>
</el-dialog>
</template>

<script>
export default {
data(){
    return{
        verificationVisible:false,
      data:{ 
        verificationTime:''
       },
      rules: {
        verificationTime:[  
        {  required: true, message: '请选择日期', 
        trigger: 'change' }]
      }
    }
},
watch:{
    verificationVisible:{
        handler(newname,oldname){
            if(oldname!=undefined&&newname==false){
                this.$refs.ruleForm.resetFields();
            }
        }
    }
},
methods:{
    showblock(data){
        this.verificationVisible=true
        this.data=data[0]
      this.data.verificationTime=''
    },
    verificheck(){
        let that=this
        this.$refs.ruleForm.validate((valid) => {
            if(valid){
                 
                that.$emit("verificheckreturn",that.data)
                that.verificationVisible=false
                 
            }
        })
    }
}
}
</script>

<style>

</style>